import { useFetchWeeklySchedule } from './hook/useFetchWeeklySchedule'
import { useFetchWeeklySchedules } from './hook/useFetchWeeklySchedules'

class WeeklyScheduleService {
  api = {
    useFetchAll: useFetchWeeklySchedules,
    useFetchOne: useFetchWeeklySchedule
  }
}

export const weeklyScheduleService = new WeeklyScheduleService()
